import React, { useState } from 'react';
import { FinalFormField } from '../Form/FinalFormField';

import { InputProps, Input } from '../Input';
import { FinalFormFieldProps } from '../Form/types';

import { IconSvg } from '../IconSvg';
import { Button } from '../Button';

export const FinalFormInputPassword = (args: FinalFormFieldProps & InputProps) => {
  const [passwordVisible, setIsVisible] = useState(false);

  const passwordSwitch = () => setIsVisible(passwordVisible => !passwordVisible);

  return (
    <FinalFormField {...args}>
      {({ input, ...rest }: FinalFormFieldProps) => {
        return (
          <Input
            autoComplete="off"
            {...input}
            {...rest}
            data-test-error={!!rest.hintError}
            data-test-error-message={rest.hintError}
            type={passwordVisible ? 'text' : 'password'}
            icon={
              <Button
                as="label"
                view="transparent"
                shape="circle"
                htmlFor={input.id}
                onClick={passwordSwitch}
                data-testid="input-password-icon"
              >
                <IconSvg src={passwordVisible ? 'eye-open' : 'eye-closed'} />
              </Button>
            }
          />
        );
      }}
    </FinalFormField>
  );
};
